import React  from 'react';
import { I18n } from 'react-redux-i18n';

// Components.
import PageSecondaryMenu from 'components/PageSecondaryMenu';

import { ReactComponent as PaymentsIcon } from './images/payments_icon.svg';
import { ReactComponent as DashboardIcon } from './images/dashboard_icon.svg';
import { ReactComponent as HelpIcon } from './images/help_icon.svg';
import { ReactComponent as LMSIcon } from './images/academy_icon.svg';
import { ReactComponent as LogoutIcon } from './images/logout_icon.svg';

import  { appURL } from 'config/index';

import styles from './styles.module.scss';

const UserProfileFooterMenu = (props) => {

  const { locationPath, classNameActiveMenu } = props;
  const actionItems = [
    {
      id: 'logout',
      name: I18n.t('Log out'),
      to: 'user/logout',
      icon: LogoutIcon
    },
  ];
  const items = [
    {
      id: 'payment-history',
      name: I18n.t('Payments'),
      href: `${appURL}/payment?utm_source=web-profile`,
      icon: PaymentsIcon
    },
    {
      id: 'lms',
      name: I18n.t('Academy'),
      to: 'lms',
      icon: LMSIcon
    },
    {
      id: 'dashboard',
      name: I18n.t('Dashboard'),
      to: 'dashboard',
      icon: DashboardIcon
    },
    {
      id: 'help',
      name: I18n.t('Help'),
      href: 'https://help.welltory.com',
      to: 'https://help.welltory.com',
      icon: HelpIcon
    },
  ];
  return (
    <div className={styles.userProfileFooterMenuWrapper}>
      <PageSecondaryMenu items={actionItems} locationPath={locationPath} className={styles.userProfileFooterMenu} classNameActiveMenu={classNameActiveMenu} />
      <PageSecondaryMenu items={items} locationPath={locationPath} className={styles.userProfileFooterMenu} classNameActiveMenu={classNameActiveMenu} />
    </div>
  );

};

export default UserProfileFooterMenu;
